import impersonateModalComponent from "../../common/modals/impersonateModal/impersonateModal.component";


class HeaderController {
  constructor(AuthenticationService, $rootScope, $state, $uibModal, $interval, $cookies, $http, HelpService) {
    "ngInject";
    this.name = 'header';
    this.auth = AuthenticationService;
    this.rootScope = $rootScope;
    this.rootScope.rightSidebar=false;
    this.state = $state;
    this.$uibModal = $uibModal;
    this.HelpService = HelpService;
    this.isMobileCollapse = true;
    this.$http = $http;
    this.logoExists = false;
    this.logoUrl = null;
    this.logoLoading = true;
    this.loadAvatarUrl();
    this.loadLogoUrl();
    
    // Listen for avatar update events from other components
    $rootScope.$on('avatarUpdated', () => {
      this.loadAvatarUrl();
    });
    
    // Listen for logo update events from other components
    $rootScope.$on('logoUpdated', () => {
      this.loadLogoUrl();
    });
  }

  openHelp($event) {
    if ($event) {
      $event.preventDefault();
    }
    if (this.HelpService.hasTopicForCurrentState()) {
      this.HelpService.openForCurrentState();
    } else {
      this.HelpService.openBrowser();
    }
  }


  authenticated() {
    return this.auth.user
  }

  goThere(item) {
    this.searchParam = undefined;
    this.state.go(item.location, item.params);
  }

  search() {
    return [
      {text: 'hi there', location: "admin.employee-details", params: {employeeId: 53}},
    ];
  }

  rightSidebar() {
    this.rootScope.rightSidebar = !this.rootScope.rightSidebar
  }

  mobileMenuClicked() {
    console.log('clicked');
    this.isMobileCollapse = !this.isMobileCollapse
  }

  impersonate() {
    let modalInstance = this.$uibModal.open(impersonateModalComponent);

    modalInstance.success = function () {
      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };

  }

  getAvatarUrl() {
    return this.avatarUrl
  }



  loadAvatarUrl() {
    let self = this;
    const avatarUrl = this.rootScope.apiHost+"/api/users/me/avatar";
    
    // Test the URL with a HEAD request to check if it exists
    this.$http.get(avatarUrl, {withCredentials: true})
      .then(function(response) {
        // Success - avatar exists
        self.avatarExists = true;
        self.avatarUrl = avatarUrl;
      })
      .catch(function(error) {
        // 404 or other error - avatar doesn't exist
        if (error.status === 404) {
          self.avatarExists = false;
          self.avatarUrl = null;
        } else {
          // Other error - assume it doesn't exist for now
          self.avatarExists = false;
          self.avatarUrl = null;
        }
      });
  }


  exitImpersonationMode() {
    window.location.href = this.rootScope.apiHost+'/api/exitimpersonation';
  }

  getLogoUrl() {
    return this.logoUrl;
  }

  loadLogoUrl() {
    let self = this;
    const logoUrl = this.rootScope.apiHost + "/api/admin/companies/1/logo";
    this.logoLoading = true;
    
    // Test the URL with a GET request to check if it exists
    this.$http.get(logoUrl, {withCredentials: true})
      .then(function(response) {
        // Success - logo exists
        self.logoExists = true;
        self.logoUrl = logoUrl;
        self.logoLoading = false;
      })
      .catch(function(error) {
        // 404 or other error - logo doesn't exist
        if (error.status === 404) {
          self.logoExists = false;
          self.logoUrl = null;
        } else {
          // Other error - assume it doesn't exist for now
          self.logoExists = false;
          self.logoUrl = null;
        }
        self.logoLoading = false;
      });
  }

}

export default HeaderController;



// WEBPACK FOOTER //
// ./client/common/header/header.controller.js